export const recaptcha = {
	google: {
		v2: {
			sitekey: '6LcKn0YgAAAAAHpQMF1kRQopWXad14NcQI2pmzdW'
		}
	}
};